import { useContext } from 'react';
import { landingBusinessContext } from '../contexts/LandingBusinessContext';

export function useLandingBusiness() {
  const value = useContext(landingBusinessContext);
  return value;
}
